export const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "S.no",
  },
  {
    id: "patientName",
    numeric: false,
    disablePadding: true,
    label: "Patient Name",
  },
  {
    id: "caseid",
    numeric: true,
    disablePadding: false,
    label: "Case ID",
  },
  {
    id: "attendingconsultant",
    numeric: true,
    disablePadding: false,
    label: "Attending Consultant",
  },
  {
    id: "contactNumber",
    numeric: true,
    disablePadding: false,
    label: "Contact Number",
  },
  {
    id: "city",
    numeric: true,
    disablePadding: false,
    label: "City",
  },
  {
    id: "lastappointment",
    numeric: true,
    disablePadding: false,
    label: "Last Appointment",
  },
  // {
  //   id: "status",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "Status",
  //   role:["branch"]
  // },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];


